import React from 'react';
import { JobProviderState } from './JobProviderState';

const state = {
    isLoading: true,
    jobList: {},
    job: {},
} as JobProviderState

const JobContext = React.createContext(state);

export default JobContext;